export default __webpack_public_path__ + "images/CO.2626211.png";